<section class="main-container" fxLayout="column" fxLayoutAlign="start center">
  <circle-progress
    [percent]="percentage"
    [outerStrokeColor]="strokeColor"
    [titleColor]="strokeColor"
    [unitsColor]="strokeColor"
  ></circle-progress>
  <h1>{{correctAnswers}}/{{totalQuestions}}</h1>
  <p>correct answers</p>
</section>
